module.exports = __webpack_public_path__ + "media/application/images/icons/search-206d14d98e92b78d1e71bc7870481d00.svg";